import * as React from 'react';
import './RoomSettingsDialog.css';

import App from 'src/state/App';
import RoomPage from 'src/state/RoomPage';

import ModalDialog from '../ModalDialog';

export type State = {
  type: 'RoomSettings',
  data: string,
};

export const Component: React.SFC<{
  store: App.Store,
  page: RoomPage,
  localState: State,
}> = ({ store, page, localState }) => {
  const dispatch = store.dispatchCurrentRoomPage;
  const hideDialog = () => RoomPage.hideDialog(dispatch);

  const apply = (() => {
    if (localState.data === '') {
      return null;
    }

    return () => {
      store.dispatchRoom(page.room, {
        type: 'set-name',
        data: localState.data,
      });

      hideDialog();
    };
  })();

  return (
    <ModalDialog
      className="room-settings-dialog"
      // title is "Set Room Name" temporarily -> TODO: expand ui and use "Room Settings"
      title="Set Room Name"
      buttons={[
        ['Cancel', hideDialog],
        ['Apply', apply],
      ]}
      bodyPadding="0"
      hidden={page.dialog.hidden}
      hideDialog={hideDialog}
    >
      <div style={{ padding: '0' }}>
        <input
          type="text"
          placeholder="Name"
          value={localState.data}
          id="new-player-textbox"
          autoFocus={true}
          onInput={(e: React.FormEvent<HTMLInputElement>) => dispatch({
            type: 'set-dialog',
            data: {
              type: 'RoomSettings',
              data: (e.target as HTMLInputElement).value,
            },
          })}
          onKeyDown={e => {
            if (apply && e.key === 'Enter') {
              apply();
            }
          }}
        />
      </div>
    </ModalDialog>
  );
};



// WEBPACK FOOTER //
// ./src/ui/Room/RoomSettingsDialog.tsx